<template>
<router-view />
</template>

<script>
export default {
  name: 'DataManagement',
  routeInfo: {
    label: '数据报表',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/index.vue